import router from '@/router';

/**
 * Entegrasyonlar sayfasına yönlendirme fonksiyonu
 * Vue Composition API içinde kullanılmak için tasarlanmıştır.
 */
export function navigateToIntegrations() {
  router.push({
    path: "/settings",
    query: { tab: "integrations" }
  });
}
